import { render } from "./CardStatsEntries.vue?vue&type=template&id=4f0dd71d"
import script from "./CardStatsEntries.vue?vue&type=script&lang=js"
export * from "./CardStatsEntries.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Cards/CardStatsEntries.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4f0dd71d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4f0dd71d', __exports__)) {
    api.reload('4f0dd71d', __exports__)
  }
  
  module.hot.accept("./CardStatsEntries.vue?vue&type=template&id=4f0dd71d", () => {
    api.rerender('4f0dd71d', render)
  })

}


export default __exports__